import { FC } from 'react';
import { cn } from '@new/lib';
import { getInitials } from '../../lib/helpers';

interface ChatAvatarProps {
  user: User;
  size?: 'sm' | 'md' | 'lg';
  isOnline?: boolean;
}

const sizeClasses = {
  sm: 'w-8 h-8 text-xs',
  md: 'w-10 h-10 text-sm',
  lg: 'w-12 h-12 text-base',
} as const;

const avatarColors = [
  'bg-[#FF6B6B] text-white',
  'bg-[#4ECDC4] text-white',
  'bg-[#45B7D1] text-white',
  'bg-[#96CEB4] text-white',
  'bg-[#FFEAA7] text-[#2D3436]',
  'bg-[#DDA0DD] text-white',
  'bg-[#98D8C8] text-white',
  'bg-[#F7DC6F] text-[#2D3436]',
];

const getColorByUserId = (userId: number): string => {
  return avatarColors[userId % avatarColors.length];
};

export const ChatAvatar: FC<ChatAvatarProps> = ({ user, size = 'md' }) => {
  const initials = getInitials(user.firstName, user.lastName);
  const colorClass = getColorByUserId(user.id);

  return (
    <div className="relative flex-shrink-0">
      {user.avatar?.url ? (
        <img
          src={user.avatar.url}
          alt={`${user.firstName} ${user.lastName}`}
          className={cn('rounded-full object-cover', sizeClasses[size])}
        />
      ) : (
        <div
          className={cn(
            'rounded-full flex items-center justify-center font-semibold',
            sizeClasses[size],
            colorClass
          )}
        >
          {initials}
        </div>
      )}
      {/* TODO: Add online status when backend ready */}
      {/* {isOnline !== undefined && (
        <span
          className={cn(
            'absolute bottom-0 right-0 w-3 h-3 rounded-full border-2 border-white',
            isOnline ? 'bg-[#47B881]' : 'bg-gray-400'
          )}
        />
      )} */}
    </div>
  );
};
